// A prévia da última mensagem, na lista de conversas.
//
// ## O defeito
//
// A lista desenhava a mensagem com `dangerouslySetInnerHTML`. A mensagem de
// boas-vindas do chat traz um `<a>` e um `<img>` (a marca da SysFar), e a
// imagem entra na linha no tamanho dela: o texto fica por baixo, ilegível
// (Gisele, Slack de 26/10/2026 — ela pediu "ajustar as cores", mas não é cor,
// é a imagem ocupando a linha).
//
// A prévia é uma LINHA de uma lista, não a conversa. O que ela precisa dizer é
// "sobre o que foi a última mensagem", e para isso texto puro basta. A lista de
// WhatsApp (`ChatList`) já fazia assim; esta era a que faltava.
//
// ## Por que DOMParser e não um `<div>` com innerHTML
//
// `innerHTML` num `<div>` solto já dispara o download das imagens: o navegador
// não espera o elemento entrar na página. Desenhar uma prévia de texto não
// pode ir buscar imagem nenhuma. `DOMParser` monta um documento inerte --
// não baixa nada, não executa nada.

/** Teto de caracteres da prévia. O corte fino quem faz é o CSS. */
export const PREVIA_MAXIMA = 120;

/** O que mostrar quando a mensagem é só uma imagem, sem texto. */
export const ROTULO_IMAGEM = 'Imagem';

/**
 * Transforma o conteúdo de uma mensagem numa linha de texto legível.
 *
 * @param {string} html conteúdo da mensagem, como veio da API
 * @returns {string} uma linha de texto puro, ou '' quando não há o que mostrar
 */
export function previaDaMensagem(html) {
    if (!html) return '';

    const doc = new DOMParser().parseFromString(String(html), 'text/html');

    /*
     * `textContent` e não `innerText`: o segundo depende de layout, e num
     * documento que nunca entra na página ele devolve string vazia.
     */
    const texto = (doc.body.textContent || '')
        // `\s` pega também o NBSP, que o HTML de e-mail usa aos montes.
        .replace(/\s+/g, ' ')
        .trim();

    if (texto !== '') {
        return texto.length > PREVIA_MAXIMA
            ? texto.slice(0, PREVIA_MAXIMA).trimEnd() + '…'
            : texto;
    }

    // Sem texto nenhum, mas com imagem: dizer "Imagem" é melhor que uma linha
    // vazia, que faria a conversa parecer sem mensagem.
    return doc.body.querySelector('img') ? ROTULO_IMAGEM : '';
}

export default previaDaMensagem;
